import React from "react";
import { connect } from "react-redux";
import { loggedIn } from "../utils/AuthService";
import { ActionLogout } from "../redux/actions";

// eslint-disable-next-line import/no-anonymous-default-export
export default function (ComposedComponent) {
  class Authenticate extends React.Component {
    componentDidMount() {
      this._checkAndRedirect();
    }

    componentDidUpdate() {
      this._checkAndRedirect();
    }

    _checkAndRedirect() {
      if (!loggedIn()) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("id");
        localStorage.removeItem("name");
        localStorage.removeItem("accessType");
        localStorage.removeItem("valid");
        localStorage.removeItem("email");
        localStorage.removeItem("tenant");
      
        this.props.history.push("/login");
      }
    }

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  const mapStateToProps = (state) => {
    return {
      authenticated: state.auth.authenticated,
    };
  };

  return connect(mapStateToProps, { ActionLogout })(Authenticate);
}
